import { render, staticRenderFns } from "./GoPro.vue?vue&type=template&id=db2427a4&scoped=true&"
import script from "./GoPro.vue?vue&type=script&lang=js&"
export * from "./GoPro.vue?vue&type=script&lang=js&"
import style0 from "./GoPro.vue?vue&type=style&index=0&id=db2427a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2427a4",
  null
  
)

export default component.exports